<template>
  <div>
    <div class="container">
      <div class="doc" style="position: relative">
        <iframe
          ref="iframe"
          id="iframe"
          title="fujian"
          src="http://ow365.cn/?i=20439&n=5&furl=7eLVSLW9buxC8FJ5nloReGjnyzQOSGSVQtKo0HAlUriEZHoCL6ex4lCPLNQmYMR3FGaTHV*fzgFfll2ME2*7qVPgJlIaI0UbgOnoKW5dfnE-"
          style="border: 0"
          width="100%"
          height="100%"
        />
      </div>
      <div>
        <el-form
          ref="xgpg_audit_form"
          :model="addFrom"
          :rules="rules"
          class="xgpg_audit_form"
        >
          <el-row style="padding-bottom: 10px">
            <el-col :span="24">
              <el-form-item label="评估类型" prop="bmbh">
                <el-select
                  v-model="addFrom.bmbh"
                  filterable
                  disabled
                  default-first-option
                  style="width: 250px"
                  placeholder="请选择任务所属部门"
                  @change="handleChangeTx"
                >
                  <el-option
                    v-for="(item, index) in bmList"
                    :key="index"
                    :label="item.bmmc"
                    :value="item.bmbh"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="scroll_row">
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>1.结构内容</div>
              </div>
              <el-form-item :label="`咨询师(${111})`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
              <el-form-item :label="`分公司`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>2.列明亮点</div>
                <div @click="historyDialog = true">过往评价报告亮点</div>
              </div>
              <el-form-item :label="`咨询师(${111})`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
              <el-form-item :label="`分公司`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>3.计划是否清晰</div>
                <el-checkbox v-model="checkbox5" disabled>是</el-checkbox>
              </div>
              <el-form-item :label="`咨询师(${111})`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
              <el-form-item :label="`分公司`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div><span>*</span>4.报告主要逻辑</div>
                <div></div>
              </div>
              <el-form-item :label="`咨询师(${111})`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
              <el-form-item :label="`分公司`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <div class="row_title">
                <div>
                  <span>*</span>5.分析是否正文分析只用于论证，不作为主要内容
                </div>
                <div>
                  <el-checkbox v-model="checkbox5" disabled>是</el-checkbox>
                </div>
              </div>
              <el-form-item :label="`咨询师(${111})`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
              <el-form-item :label="`分公司`" prop="txlx">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  maxlength="200"
                  placeholder="请输入备注"
                  v-model="addFrom.bz"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="柳州市区联社-效果评估策略制定-过往评估的主题"
      :visible.sync="historyDialog"
      width="80%"
      v-if="historyDialog"
      append-to-body
      id="history-dialog"
    >
      <div>
        <div class="history_row">
          <div>申请日期： 2023/12/20</div>
          <div>申请人： 张三</div>
          <div>效果评估类型： 半年评估</div>
        </div>
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 6 }"
            maxlength="200"
            placeholder="请输入备注"
            disabled
            v-model="addFrom.bz"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="historyDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="评审结果确认"
      :visible.sync="adviceDialog"
      width="80%"
      v-if="adviceDialog"
      append-to-body
    >
      <div>
        <div>
          <div class="advice_row">
            <div>整体意见</div>
            <div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 6, maxRows: 6 }"
                maxlength="200"
                placeholder="请输入备注"
                disabled
                v-model="addFrom.bz"
              />
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="historyDialog = false"
          >确 认</el-button
        >
        <el-button @click="adviceDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import {
  getBmxxList,
  getKeyValue,
  getTaskZlList,
  getTasklxList,
} from "@/api/taskType.js";
import {
  saveReviewer,
  getJdlxSelector,
  getReviewerById,
} from "@/api/reviewer.js";

export default {
  name: "viewAudit",
  computed: {
    ...mapGetters(["deptUser"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      historyDialog: false,
      adviceDialog: false,
      checkbox5: true,
      addFrom: {
        txlx: null,
        jdlx: null,
        txlx: null,
        name: null,
        sun: null,
        bmbh: null,
        id: null,
        bz: null,
      },
      rules: {},
      bmList: [],
      lxList: [],
      jdlxList: [],
      zlList: [],
      ygtxoptions: [],
      shrList: [],
      parentDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.addFrom.id = this.mxParams.id;
    getReviewerById({ id: this.addFrom.id }).then((res) => {
      if (res.code == 0) {
        this.addFrom = res.data.reviewer;
        this.addFrom.jdlx = this.addFrom.jdlx + "";
        this.shrList = res.data.audit;
        for (let i in this.shrList) {
          this.shrList[i].ygbh = this.shrList[i].reviewer;
          this.shrList[i].id = Number(i) + 1;
        }
        getTaskZlList(
          this.addFrom.name,
          this.addFrom.bmbh,
          this.addFrom.txlx
        ).then((res2) => {
          if (res2.code == 0) {
            this.zlList = res2.data;
          }
        });
      }
    });
    getBmxxList("1").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    getKeyValue("TXLX", "", "1").then((res) => {
      if (res.code === 0) {
        this.ygtxoptions = res.data;
      }
    });

    getJdlxSelector().then((res) => {
      if (res.code == 0) {
        this.jdlxList = res.data.jdlxList;
      }
    });
  },
  methods: {
    handleChangeRlsh(e) {
      this.addFrom.isReview = e;
    },

    handleChangeDrel(e) {
      this.addFrom.isMultiple = e;
    },
    handleEdit() {
      let reviewer = [];
      if (this.shrList.length == 0) {
        this.$message({
          message: "审核人不能为空",
          type: "error",
        });
        return;
      }
      for (let i of this.shrList) {
        if (i.ygbh) {
          reviewer.push(i.ygbh);
        } else {
          this.$message({
            message: "审核人不能为空",
            type: "error",
          });
          return;
        }
      }
      reviewer = reviewer.toString();
      const params = { ...this.addFrom, reviewer };
      saveReviewer(params).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleAddTd() {
      const len = this.shrList.length;
      if (len == 0) {
        this.shrList.push({ id: 1, ygbh: null, gwmc: null });
      } else {
        this.shrList.push({
          id: this.shrList[len - 1].id + 1,
          ygbh: null,
          gwmc: null,
        });
      }
    },
    handleDelTd(id) {
      const temp = [];
      for (let i of this.shrList) {
        if (i.id != id) {
          temp.push(i);
        }
      }
      this.shrList = temp;
    },
    handleSelectYg(e) {
      // this.shrList
      setTimeout(() => {
        for (let i in this.shrList) {
          if (this.shrList[i].ygbh == e.ygbh) {
            this.shrList[i].gwmc = e.gwmc;
          }
        }
      }, 50);
    },
    handleChangeZl() {
      getTaskZlList(
        this.addFrom.name,
        this.addFrom.bmbh,
        this.addFrom.txlx
      ).then((res) => {
        if (res.code == 0) {
          this.zlList = res.data;
          this.addFrom.jdlx = null;
          this.addFrom.sun = null;
        }
      });
    },
    handleChangeTx(i) {
      this.listQuery.bmbh = i;
      this.listQuery.bmmc = i;
      getKeyValue("TXLX", i, "1").then((res) => {
        if (res.code === 0) {
          this.ygtxoptions = res.data;
        }
      });
    },
    handleChangeLx() {
      getTasklxList(this.addFrom.bmbh, this.addFrom.txlx).then((res) => {
        if (res.code == 0) {
          this.lxList = res.data;
          this.addFrom.jdlx = null;
          this.addFrom.sun = null;
        }
      });
    },
    handleShowAdvice() {
      this.adviceDialog = true;
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 55px;
}
.table {
  .table-header {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #f2f2f2;
    display: flex;
    justify-content: center;
    > div {
      width: 20%;
      display: flex;
      justify-content: center;
      > div {
        color: #036eb8;
        padding: 0 10px;
        font-size: 25px;
        cursor: pointer;
      }
    }
    > div:nth-of-type(2) {
      width: 40%;
    }
  }
  .table-none {
    text-align: center;
    color: #999;
    margin: 10px 0;
  }
  .table-body {
    .table-tr {
      display: flex;
      height: 44px;
      line-height: 44px;
      text-align: center;
      display: flex;
      justify-content: center;
      border-bottom: 1px solid #f2f2f2;
      // border-left: 1px solid #f2f2f2;
      .table-td {
        display: flex;
        justify-content: center;
        width: 20%;
        // border-right: 1px solid #f2f2f2;
      }
      .table-td:nth-of-type(2) {
        width: 40%;
      }
      .del {
        color: #ff0000;
        cursor: pointer;
      }
    }
  }
}
.scroll_row {
  max-height: 500px;
  overflow: auto;
  width: calc(100% + 20px);
  padding: 15px 30px 0 0;
  border-top: 1px solid #dcdfe6;
  .row_title {
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    div:nth-of-type(1) {
      text-align: right;
    }
    div:nth-of-type(2) {
      color: #036eb8;
      cursor: pointer;
    }
    span {
      color: #f56c6c;
    }
  }
}
.history_row {
  display: flex;
  div {
    margin-right: 30px;
    line-height: 44px;
  }
}
.advice_row {
  display: flex;
  width: 100%;
  > div:nth-of-type(1) {
    width: 70px;
  }
  > div:nth-of-type(2) {
    width: calc(100% - 70px);
  }
}
.container {
  display: flex;
  > div:nth-of-type(1) {
    width: 65%;
  }
  > div:nth-of-type(2) {
    width: 35%;
    padding-left: 15px;
  }
}
::v-deep.xgpg_audit_form .el-form-item {
  margin-bottom: 0;
}
</style>